export default __webpack_public_path__ + "static/marketplace-og-3c8473656fe7917d7c900f8463538836.png";